// extracted by mini-css-extract-plugin
export default {"description":"CardDescription_description__ilu1f"};